type OnboardingUserFile = {
    category: string;
    fileName: string;
    key: string;
    uploadedAt: string;
    uploadId: string;
    expiryDate?: string;
};

export type OnboardingUserValues = {
    confirmComplaints: boolean;
    confirmRestrictions: boolean;
    confirmOnPerformersList: boolean;
    confirmNotPerformersListSuspended: boolean;
    confirmObligations: boolean;
    confirmAcceptTerms: boolean;
    confirmCorrect: boolean;
    confirmUnansweredFollowup: boolean;
    confirmBasicAdvancedLifeSupport: boolean;
    confirmSafeguardingAdults: boolean;
    confirmSafeguardingChildren: boolean;
    receiveMarketing: boolean;
    name: string;
    phoneNumber: string;
    email: string;
    hcpType: string;
    professionalBodyRegistrationRequired: string;
    professionalBodyType: string;
    professionalBodyId: string;
    primaryGPFunction: string;
    gmcRegistrationDate: string;
    dateOfBirth: string;
    niNumber: string;
    addressLine1: string;
    addressLine2: string;
    town: string;
    county: string;
    postCode: string;
    emergencyContact: string;
    deviceType: string;
    nameOnAccount: string;
    accountNumber: string;
    sortCode: string;
    tradingStatus: string;
    inNHSPension: string;
    pensionSDNumber: string;
    pensionTierDeduction: string;
    companyName: string;
    companyRegistrationNumber: string;
    vatRegistered: string;
    vatRegistrationNumber: string;
    equalityGender: string;
    equalityGenderOther: string;
    equalityMaritalStatus: string;
    equalityEthnicOrigin: string;
    equalityCountryOfBirth: string;
    equalityNationality: string;
    equalityDisability: string;
    equalityReligiousBeliefs: string;
    equalitySexualOrientation: string;
    specialities: string[];
    specialitiesOther: string;
    languages: string[];
    languagesOther: string;
    practiceName: string;
    practiceODSCode: string;
    nhsSmartcardNo: string;
    nhsEmail: string;
    medicalIndemnityOrganisation: string;
    hasCurrentDrivingLicence: string;
    drivingLicenceNumber: string;
    hasCarBusinessInsurance: string;
    hasConviction: string;
    convictionDetails: string;
    reference1FullName: string;
    reference1Address1: string;
    reference1Address2: string;
    reference1Town: string;
    reference1County: string;
    reference1PostCode: string;
    reference1Telephone: string;
    reference1Email: string;
    reference1EmailConfirm: string;
    reference2FullName: string;
    reference2Address1: string;
    reference2Address2: string;
    reference2Town: string;
    reference2County: string;
    reference2PostCode: string;
    reference2Telephone: string;
    reference2Email: string;
    reference2EmailConfirm: string;
    vaccinations: string[];
    covidStatus: string;
    elfhRegistered: string;
    training: string[];
    systemProficiency: string[];
    systemProficiencyOther: string;
    files: OnboardingUserFile[];
};

const defaultValues: OnboardingUserValues = {
    name: '',
    phoneNumber: '',
    email: '',
    hcpType: '',
    professionalBodyRegistrationRequired: 'no',
    professionalBodyType: '',
    professionalBodyId: '',
    primaryGPFunction: '',
    gmcRegistrationDate: '',
    confirmComplaints: false,
    confirmRestrictions: false,
    confirmOnPerformersList: false,
    confirmNotPerformersListSuspended: false,
    confirmObligations: false,
    confirmAcceptTerms: false,
    dateOfBirth: '',
    niNumber: '',
    addressLine1: '',
    addressLine2: '',
    town: '',
    county: '',
    postCode: '',
    emergencyContact: '',
    deviceType: '',
    nameOnAccount: '',
    accountNumber: '',
    sortCode: '',
    tradingStatus: 'INDIVIDUAL',
    inNHSPension: '',
    pensionSDNumber: '',
    pensionTierDeduction: '',
    companyName: '',
    companyRegistrationNumber: '',
    vatRegistered: '',
    vatRegistrationNumber: '',
    equalityGender: '',
    equalityGenderOther: '',
    equalityMaritalStatus: '',
    equalityEthnicOrigin: '',
    equalityCountryOfBirth: '',
    equalityNationality: '',
    equalityDisability: '',
    equalityReligiousBeliefs: '',
    equalitySexualOrientation: '',
    specialities: [],
    specialitiesOther: '',
    languages: [],
    languagesOther: '',
    practiceName: '',
    practiceODSCode: '',
    nhsSmartcardNo: '',
    nhsEmail: '',
    medicalIndemnityOrganisation: '',
    hasCurrentDrivingLicence: '',
    drivingLicenceNumber: '',
    hasCarBusinessInsurance: '',
    hasConviction: '',
    convictionDetails: '',
    reference1FullName: '',
    reference1Address1: '',
    reference1Address2: '',
    reference1Town: '',
    reference1County: '',
    reference1PostCode: '',
    reference1Telephone: '',
    reference1Email: '',
    reference1EmailConfirm: '',
    reference2FullName: '',
    reference2Address1: '',
    reference2Address2: '',
    reference2Town: '',
    reference2County: '',
    reference2PostCode: '',
    reference2Telephone: '',
    reference2Email: '',
    reference2EmailConfirm: '',
    vaccinations: [],
    covidStatus: '',
    training: [],
    elfhRegistered: '',
    systemProficiency: [],
    systemProficiencyOther: '',
    confirmCorrect: false,
    confirmUnansweredFollowup: false,
    receiveMarketing: false,
    confirmBasicAdvancedLifeSupport: false,
    confirmSafeguardingAdults: false,
    confirmSafeguardingChildren: false,
    files: [],
};

export default defaultValues;
